<div style="width: 0px" container="body" triggers="manual" placement="bottom top"></div>
<span>
  <strong class="aniborder">
     {{name}}
  </strong>
</span>
